// extracted by mini-css-extract-plugin
module.exports = {"Device":"Device_Device__1-6ZC"};